import React from 'react'
import { API_URL } from '../configs/events-api'
import { getUser } from './auth'
import { Api, createActions } from 'jetset'
const user = getUser()
export const deleteMultipleEvents = events => {
  const data = { events }

  return fetch(`${API_URL}/events/batchDelete`, {
    method: 'POST',
    body: JSON.stringify(data),
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${user.token}`,
    },
  }).then(response => {
    if (response.ok) {
      return response.json()
    }
    return Promise.reject(response)
  })
}

export const saveMultipleEvents = ({ action, actors }) => {
  const user = getUser()
  const data = { eventType: action, actors }

  return fetch(`${API_URL}/events/multiple`, {
    method: 'POST',
    body: JSON.stringify(data),
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${user.token}`,
    },
  }).then(response => {
    if (response.ok) {
      return response.json()
    }
    return Promise.reject(response)
  })
}

export const saveEvent = ({ action, actor }) => {
  const user = getUser()
  const data = { eventType: action, actor }

  const api = createActions({
    url: process.env.API_URL,
    events: '/events',
    authorization: `Bearer ${user.token}`,
  })

  api.events.create(data, { refetch: false }).then(response => {
    if (response.id) {
      return response
    }
    return Promise.reject(response)
  })
}

export const useAdminEventApi = Component => (
  <Api url={process.env.API_URL} events="/events" authorization={user.token}>
    <Component />
  </Api>
)
